"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

require("./ProgressBarComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ProgressBarComponent = function ProgressBarComponent(_ref) {
  var percent = _ref.percent,
      size = _ref.size,
      className = _ref.className,
      showInfo = _ref.showInfo,
      status = _ref.status,
      strokeColor = _ref.strokeColor,
      strokeLinecap = _ref.strokeLinecap,
      steps = _ref.steps;
  return /*#__PURE__*/_react["default"].createElement(_antd.Progress, {
    percent: percent,
    size: size || "default",
    className: className || "",
    showInfo: showInfo || "false",
    status: status || "active",
    strokeColor: strokeColor,
    strokeLinecap: strokeLinecap || "round",
    steps: steps
  });
};

var _default = ProgressBarComponent;
exports["default"] = _default;